export enum EUserPermissions {
  PERMISSION_PERMISSIONS = 1,
  PERMISSION_INSTALLER = 2,
  PERMISSION_REMOTE_OPEN_CELLS = 3,
  PERMISSION_DEVELOPER = 4,
  PERMISSION_ADMINISTRATOR = 10,
  PERMISSION_SETTINGS_ADMINISTRATOR = 11,
  PERMISSION_LOCKER_OWNER = 101,
  PERMISSION_LOCKER_OPERATOR = 102,
  PERMISSION_LOCKER_FACTORY = 109,
  PERMISSION_INTERNAL_DELIVERY_PERSON = 110,
  PERMISSION_CHANNEL_ADMINISTRATOR = 201,
  PERMISSION_SERVICE_PROVIDER_OWNER = 301,
  PERMISSION_SERVICE_PROVIDER_OPERATOR = 302,
  PERMISSION_MASS_IMPORT = 500,
  PERMISSION_DASHBOARD = 520,
  PERMISSION_MARKETING = 701,
  PERMISSION_PRODUCT = 702,
  PERMISSION_OPERATIONS = 703,
  PERMISSION_DRIVER = 901,
  PERMISSION_API_G1 = 1001,
}
